import React from 'react';

import { AuthState } from '../login/auth';

// Create a context for authentication state
export const AuthContext = React.createContext<AuthState | null>(null);

interface AuthProviderProps {
    auth: AuthState;
    children: React.ReactNode;
}

/**
 * Provider component for authentication state
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ auth, children }) => {
    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
